import React from 'react';
import FilterList from '../../../components/user/task/taskFilterList';
import Layout from '../../../components/layouts/verticalLayout';

const TaskListPage = (props) => {
  return <Layout body={<FilterList />} />;
};

TaskListPage.propTypes = {};

export default TaskListPage;
